import * as React from "react";
const SvgArrowicon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M160 115.4 180.7 96 352 256 180.7 416 160 396.7 310.5 256z" }));
export default SvgArrowicon;
